import DividendsPage, { dividendsQuery } from "@app/pages/dividends/dividends-page";
import type { dividendsPage_Query } from "@app/queries/dividendsPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/dividends")({
  // Page-owned and all-time, exempt from the global date-range lens like /loans:
  // ownership is cumulative and a cap table only makes sense read end to end.
  loader: () =>
    loadQuery<dividendsPage_Query>(environment, dividendsQuery, {}, { fetchPolicy: "network-only" }),
  head: () => pageHead("Dividends"),
  component: DividendsRoute,
});

function DividendsRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary fallback={<div className="p-6 text-red-500">Error loading dividends</div>}>
      <Suspense fallback={<div className="p-6 text-gray-500">Loading dividends…</div>}>
        <DividendsPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
